import { BaseRequestsService } from '@/services/base-requests-service';

class FavoriteRequests extends BaseRequestsService {

  /**
   * @async
   * @method
   * @param {Object} options
   */
  // getFavorites(options, query = {}) {
  //   return this.http.post('v2/favorites/list', options, query);
  // }

  getFavorites(data) {
    return this.http.get('v3/favorites/list', {
      params: { ...data },
    });
  }

  updateFavorite(id, options) {
    return this.http.patch(`v3/favorites/${id}`, options);
  }

  deleteFavorite(id) {
    return this.http.delete(`v3/favorites/${id}`);
  }

  checkFavorite(id, type) {
    return this.http.get(`v3/favorites/${id}/check?paymentProviderType=${type}`);
  }

  createFavoriteWithId(options) {
    return this.http.post('v3/favorites/byPaymentUuid', options);
  }

  createTransferFavorite(options) {
    return this.http.post('v2/favorites/transfer', options);
  }

  createPaymentFavorite(options) {
    return this.http.post('v3/favorites/create', options);
  }
  refreshFavorites() {
    return this.http.get('v3/favorites/dept/refresh');
  }

}

const favoriteRequests = new FavoriteRequests();
export { favoriteRequests as FavoriteRequests };
